module.exports = __webpack_public_path__ + "static/img/efe84c9b.svg";